<template>
  <div class="app-page-shell">
    <div class="app-page-shell__header">
      <div>
        <h2 class="app-page-shell__title">
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="app-page-shell__subtitle"
        >
          {{ subtitle }}
        </p>
      </div>
      <div
        v-if="$slots.actions"
        class="app-page-shell__actions"
      >
        <slot name="actions" />
      </div>
    </div>

    <b-card
      no-body
      class="app-page-shell__surface"
    >
      <slot />
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'AppPageShell',
  components: {
    BCard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.app-page-shell {
  min-width: 0;
}

.app-page-shell__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.app-page-shell__title {
  margin-bottom: .25rem;
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1.25;
  color: #2f2f3b;
}

.app-page-shell__subtitle {
  max-width: 760px;
  margin-bottom: 0;
  color: #6e6b7b;
}

.app-page-shell__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: .5rem;
  flex-shrink: 0;
}

.app-page-shell__surface {
  overflow: hidden;
  border: 1px solid rgba(34, 41, 47, .08);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(34, 41, 47, .06);
}

@media (max-width: 767.98px) {
  .app-page-shell__header {
    flex-direction: column;
  }

  .app-page-shell__actions {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
</style>
